/*
 * Layout Name: Cards CTA
 * Desc:
 */
import { useScrollPosition } from "@n8tb1t/use-scroll-position"
import React, { useState } from "react"
import { connect } from "react-redux"
import ReactSelect from "react-select"
import Button from "@components/objects/Button/Button"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./MoodboardSelectBar.module.scss"

const locationSelectStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: state.isFocused ? "0 0 0 0px #ccc" : 0,
    backgroundColor: "#f4f7fc",
    border: "none",
    borderRadius: "5px",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 0,
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.5,
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: 2,
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#fd78de",
    ":hover": {
      backgroundColor: "#fd78de",
      color: "white",
    },
  }),
}

const MoodboardSelectBar = ({
  clearAllSelectedImages,
  clearAllFilters,
  handleSubmit,
  isImageSelected,
  selectFilters,
  staticData,
  handleSelectChange,
}) => {
  const [showBar, setShowBar] = useState(false)
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y < -250
      if (isShow !== showBar) {
        setShowBar(isShow)
      }
    },
    [showBar]
  )

  const { styleOptions, categoryOptions, settingOptions } = staticData

  // use all service or filter options by category when selected
  const serviceTagOptions =
    selectFilters.category && categoryOptions
      ? categoryOptions.find((option) => option.value === selectFilters.category).tags
      : staticData.serviceTagOptions

  return (
    <section className={`${styles.MoodboardSelectBar} ${showBar ? styles.showBar : ""}`}>
      <div className={styles.bar}>
        <SiteWrapper full className={styles.wrapper}>
          <div className={styles.grid}>
            <h1 className={styles.title}>Mood-Boards</h1>
            <p className={styles.tagline}>
              Select your favourite pictures and we'll show the best suppliers
            </p>
            <div className={styles.actions}>
              <div className={styles.selects}>
                <ReactSelect
                  styles={locationSelectStyles}
                  name="category"
                  placeholder="Party Type"
                  isMulti={false}
                  isClearable
                  isSearchable
                  onChange={handleSelectChange}
                  options={categoryOptions}
                  value={
                    categoryOptions &&
                    categoryOptions.filter((option) => option.value === selectFilters.category)
                  }
                />
                <ReactSelect
                  styles={locationSelectStyles}
                  name="service"
                  placeholder="Moodboards"
                  isMulti={false}
                  isClearable
                  isSearchable
                  onChange={handleSelectChange}
                  options={serviceTagOptions}
                  value={
                    serviceTagOptions &&
                    serviceTagOptions.filter((option) => option.value === selectFilters.service)
                  }
                />
                <ReactSelect
                  styles={locationSelectStyles}
                  name="style"
                  placeholder="Style"
                  isMulti={false}
                  isClearable
                  isSearchable
                  onChange={handleSelectChange}
                  options={styleOptions}
                  value={
                    styleOptions &&
                    styleOptions.filter((option) => option.value === selectFilters.style)
                  }
                />
                <ReactSelect
                  styles={locationSelectStyles}
                  name="setting"
                  placeholder="Setting"
                  isMulti={false}
                  isClearable
                  isSearchable
                  onChange={handleSelectChange}
                  options={settingOptions}
                  value={
                    settingOptions &&
                    settingOptions.filter((option) => option.value === selectFilters.setting)
                  }
                />
              </div>

              <div className={styles.buttons}>
                <Button
                  className={styles.clearButton}
                  design="outline"
                  color="dark"
                  text="Deselect All"
                  onClick={clearAllSelectedImages}
                  disabled={!isImageSelected}
                />

                <Button
                  className={styles.submitButton}
                  text="Next"
                  color="dark"
                  onClick={handleSubmit}
                  disabled={!isImageSelected}
                />
              </div>
            </div>
          </div>
        </SiteWrapper>
      </div>
    </section>
  )
}

const mapStateToProps = (state) => ({
  staticData: state.staticData.data,
})

export default connect(mapStateToProps, null)(MoodboardSelectBar)
